export default __webpack_public_path__ + "static/media/landingPage_5.253d7faa.jpg";